<template>
  <pt-notes-detail class="pt-notes-detail__withData" :id="id" :notesDetail="notesDetail" @cancelSign="cancelSign" :signId="signId"
  :cancelLoading="cancelLoading" :loading="loading" :signDetail="signDetail" @invalidSign="invalidSign" @signNotesDetail="signNotesDetail" :invalidLoding="invalidLoding"></pt-notes-detail>
</template>

<script>
import PtNotesDetail from './index'
export default {
  name: 'pt-notes-detail__withData',
  components: {
    'pt-notes-detail': PtNotesDetail
  },
  props: {
    id: {
      type: String
    },
    signId: {
      type: String
    }
  },
  data () {
    return {
      notesDetail: {},
      cancelLoading: false,
      signDetail: {},
      detailLoading: false,
      notesLoading: false,
      invalidLoding: false
    }
  },
  computed: {
    loading () {
      return this.detailLoading || this.notesLoading
    }
  },
  methods: {
    invalidSign () {
      this.invalidLoding = true
      this.$store.dispatch('getSignInvalid', this.id).then(res => {
        this.$message.success('设置成功')
        this.invalidLoding = false
        this.signNotesDetail()
      }).catch(err => {
        this.invalidLoding = false
        this.$message.error(err || '设置失效失败')
      })
    },
    getSignDetail () {
      this.detailLoading = true
      this.$store.dispatch('getSignDetail', this.signId).then(res => {
        this.detailLoading = false
        this.signDetail = res
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取报名详情失败')
      })
    },
    cancelSign () {
      this.cancelLoading = true
      this.$store.dispatch('cancelSign', this.id).then(res => {
        this.cancelLoading = false
        this.$message.success('取消报名成功')
        this.signNotesDetail()
      }).catch(err => {
        this.cancelLoading = false
        this.$message.error(err || '取消报名失败')
      })
    },
    signNotesDetail () {
      this.notesLoading = true
      this.$store.dispatch('signNotesDetail', this.id).then(res => {
        this.notesLoading = false
        this.notesDetail = res
      }).catch(err => {
        this.notesLoading = false
        this.$message.error(err || '获取报名记录详情失败')
      })
    }
  },
  created () {
    this.signNotesDetail()
    this.getSignDetail()
  }
}
</script>
